import { apiV1 } from './api';

const getTasks = (options = {}) => {
  const {
    isFilterDisabled,
    page = 1,
    perPage = 25,
    taskType,
    tags = [],
    operators = [],
    details = [],
    signal,
  } = typeof options === 'boolean' ? { isFilterDisabled: options } : options;

  return apiV1
    .get('/tasks', {
      params: {
        ignore_operator_filter: isFilterDisabled,
        page,
        per_page: perPage,
        task_type: taskType,
        tags,
        operators,
        details,
      },
      signal,
    })
    .then(({ data }) => data);
};

const deleteTask = taskId => apiV1.delete(`tasks/${taskId}`).then(({ data }) => data);

export const tasksAPI = {
  getTasks,
  deleteTask,
};
